import React from 'react';
import {Switch} from '@mui/material';

export default function SwitchComponent({
                                            input: {onChange, value},
                                            meta,
                                            ...props
                                        }) {
    const handleChange = (event) => {
        onChange(event.target.checked);
    };

    return (
        <Switch
            checked={!!value}
            onChange={handleChange}
            sx={styles}
            {...props}
        />
    );
};

const styles = {
    mb: '10px',
    "& .MuiSwitch-switchBase.Mui-checked": {
        color: '#003300'
    },
    "& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
        backgroundColor: '#003300'
    },
    "&:hover .MuiSwitch-switchBase": {
        color: '#003300'
    },
}